import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowDown } from 'lucide-react';
interface YellowButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  fullWidth?: boolean;
  variant?: 'primary' | 'outline' | 'danger';
  icon?: 'arrow-right' | 'arrow-down' | 'none';
  size?: 'sm' | 'md' | 'lg';
}
export function YellowButton({
  children,
  fullWidth = false,
  variant = 'primary',
  icon = 'none',
  size = 'md',
  className = '',
  ...props
}: YellowButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold uppercase tracking-wide transition-all duration-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 focus:ring-offset-black disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-yellow-500 text-black hover:bg-yellow-400 shadow-[0_0_15px_rgba(234,179,8,0.4)] hover:shadow-[0_0_25px_rgba(234,179,8,0.6)] border border-transparent',
    outline: 'bg-transparent border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500/10',
    danger: 'bg-red-600 text-white hover:bg-red-500 shadow-lg border border-transparent'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-325">
      {children}
      {icon === 'arrow-right' && <ArrowRight className="ml-2 w-5 h-5" data-id="element-326" />}
      {icon === 'arrow-down' && <ArrowDown className="ml-2 w-5 h-5" data-id="element-327" />}
    </motion.button>;
}